module.exports = __webpack_public_path__ + "img/enter-pin-xs.6db3302a.png";